import api from '../api';

// Owns the grade/edit/delete mutations for a chore log entry. Shared by
// useChores (Chores tab) and useAnalytics (Analytics tab), which both act on
// the same /chores/logs/:id endpoints but keep their own separate log lists —
// so each caller passes its own refetch function to run after a mutation.
// Confirmation for the destructive delete lives in the UI layer (a styled
// dialog), not here — this hook only fires once the caller has confirmed.
export default function useLogMutations(refetchLogs) {
  const gradeLog = async (logId, gradeData) => {
    try {
      await api.post(`/chores/logs/${logId}/grade`, gradeData);
      await refetchLogs();
      return true;
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.error || "Failed to submit grade");
      return false;
    }
  };

  const editLog = async (logId, logData) => {
    try {
      await api.patch(`/chores/logs/${logId}`, logData);
      await refetchLogs();
      return true;
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.error || "Failed to update log");
      return false;
    }
  };

  const deleteLog = async (logId) => {
    try {
      await api.delete(`/chores/logs/${logId}`);
      await refetchLogs();
      return true;
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.error || "Failed to delete log");
      return false;
    }
  };

  const editGrade = async (logId, gradeData) => {
    try {
      await api.patch(`/chores/logs/${logId}/grade`, gradeData);
      await refetchLogs();
      return true;
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.error || "Failed to update review");
      return false;
    }
  };

  return { gradeLog, editLog, deleteLog, editGrade };
}
